// Город доставки покупателя для карточки товара: выбранный в блоке
// «Доставка» (запоминаем в браузере), иначе город адреса по умолчанию, иначе
// Москва. Хранилище может быть закрыто (приватный режим) — тогда просто не
// запоминаем.
const KEY = "osmix.delivery.city";
export const DEFAULT_DELIVERY_CITY = "Москва";

export const readDeliveryCity = (): string | null => {
	try {
		return localStorage.getItem(KEY)?.trim() || null;
	} catch {
		return null;
	}
};

export const saveDeliveryCity = (city: string): void => {
	try {
		localStorage.setItem(KEY, city.trim());
	} catch {
		// недоступно — без запоминания
	}
};
